import { InvoiceStatus } from '../../models/billingHistory/billingHistory';

export const statuses: Readonly<InvoiceStatus[]> = [
  'paid',
  'voided',
  'pending',
  'draft',
  'open',
  'canceled',
];

export const FILTERS_WIDTH = 220;
